.container {
  overflow: hidden;
  min-width: 30%;
  display: flex;
  flex: 1;
  flex-direction: column;
}

/* Takes the feed's place, so the composer stays at the bottom */
.empty {
  flex: 1;
}

.feedItemContent {
  flex: 1;
}
